<template>
    <div class="content">
        <net-resource></net-resource>
        <!--<inner-original-manuscript></inner-original-manuscript>-->
        <new-share-manuscript></new-share-manuscript>
        <today-adopt-manuscript></today-adopt-manuscript>
    </div>
</template>

<script>
    import NetResource from '@/views/index/rightSection/netResource.vue'
    import NewShareManuscript from '@/views/index/rightSection/newShareManuscript.vue'
    import TodayAdoptManuscript from '@/views/index/rightSection/todayAdoptManuscript.vue'
    import InnerOriginalManuscript from '@/views/index/rightSection/innerOriginalManuscript.vue'

    export default {
        name: "Content",
        data() {
            return{

            }
        },
        components: { NewShareManuscript, TodayAdoptManuscript, InnerOriginalManuscript,NetResource },
        created(){},
        mounted() {},
        computed:{},
        methods:{},
        beforeDestroy() {},
    }
</script>

<style scoped>
.content{
    width: 760px;
}
</style>
